import {
    IDataArray,
} from "./../../shared/index"

export class SurveyCompany implements IDataArray {
    public Pkid = 0;
    public SurveyId: number;
    public CompanyId: number;

    public GetById(): number {
        return this.Pkid;
    }
}